import React from 'react';
import {Checkbox, Radio} from 'antd';
const RadioGroup = Radio.Group;
import {WeaSearchGroup, WeaFormItem, WeaInput} from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import EType from './base/EType';
import ETitle from './base/ETitle';
import WeaMaterialLib from './base/WeaMaterialLib';

// 音频元素
export default class Content_audio extends React.Component {
    state = {
        eAudioShow: this.props.eAudioShow,
        eAudioForm: this.props.eAudioForm
    };

    render() {
        const {eAudioShow, eAudioForm} = this.state;

        let EShowSetting = <div></div>;
        let EAudioFrom = <div></div>;
        if (this.props.eShareLevel == '2') {
            EShowSetting = (
                <WeaFormItem label={getLabel(33549, '显示设置')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                    <span>{getLabel(386530, '高度：')}</span>
                    <WeaInput value={eAudioShow.height} style={{width: '50px'}} onChange={value => this.setState({eAudioShow: {...eAudioShow, height: value}})}/>
                    <Checkbox checked={eAudioShow.autoPlay} style={{marginLeft: '10px'}} onChange={e => this.setState({eAudioShow: {...eAudioShow, autoPlay: e.target.checked}})}>{getLabel(22840, '自动播放')}</Checkbox>
                </WeaFormItem>
            );

            const radioStyle = {
                display: 'block',
                height: '30px',
                lineHeight: '30px',
                marginBottom: '5px'
            };
            EAudioFrom = (
                <WeaFormItem label={getLabel(23786, '音频来源')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                    <RadioGroup value={eAudioForm.type || '1'} onChange={e => this.setState({eAudioForm: {...eAudioForm, type: e.target.value}})}>
                        <Radio style={radioStyle} value="1">{getLabel(125333, '选择文件')}</Radio>
                        <Radio style={radioStyle} value="2">{getLabel(386575, 'URL路径')}</Radio>
                    </RadioGroup>
                    <div style={{position: 'absolute', top: 0, left: 0, width: '100%', marginLeft: '85px', paddingRight: '85px'}}>
                        <div style={radioStyle}>
                            <WeaMaterialLib value={eAudioForm.src} onChange={value => this.setState({eAudioForm: {...eAudioForm, src: value}})}/>
                        </div>
                        <div style={radioStyle}>
                            <WeaInput value={eAudioForm.url} onChange={value => this.setState({eAudioForm: {...eAudioForm, url: value}})}/>
                        </div>
                    </div>
                </WeaFormItem>
            );
        }

        return (
            <div>
                <WeaSearchGroup title={getLabel(81711, '基本信息')} needTigger={true} showGroup={true}>
                    <EType ref="eType" value={this.props.eBaseName}/>
                    {this.props.eShareLevel == '2' ? <ETitle ref="eTitle" eid={this.props.eid} value={this.props.eTitle}/> : ''}
                    {EShowSetting}
                    {EAudioFrom}
                </WeaSearchGroup>
            </div>
        );
    }

    getSaveValues() {
        return {
            eContentTitle: this.refs['eTitle'] ? this.refs['eTitle'].getSaveValues() : this.props.eTitle,
            eContentAudioShow_height: this.state.eAudioShow.height,
            eContentAudioShow_autoPlay: this.state.eAudioShow.autoPlay,
            eContentAudioForm_type: this.state.eAudioForm.type || '1',
            eContentAudioForm_src: this.state.eAudioForm.src,
            eContentAudioForm_url: this.state.eAudioForm.url
        };
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_audio.js